import Section from '@audioeye-marketing/ui/src/components/Section'
import Container from '@audioeye-marketing/ui/src/components/Container'
import colors from '@audioeye-marketing/ui/src/theme/colors'
import ScannerForm from '@/components/storyblok/items/ScannerForm'
import translateSectionStyles from '@/lib/translate-section-styles'

const ScannerOnlySection = () => {
  const sectionStyles = translateSectionStyles({
    background_color: { value: colors.common.white },
    collapse_bottom_padding: true,
  })

  return (
    <Section {...sectionStyles} padding="sm">
      <Container constraint="md">
        <ScannerForm
          horizontalForm
          blok={{ heading: `Test your site's accessibility for free — see results instantly`, button_text: 'Scan Now' }}
        />
      </Container>
    </Section>
  )
}

export default ScannerOnlySection
